'use client';
import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import { Swiper as SwiperType } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import TestimonialWaveCard, { type TestimonialWaveCardProps } from './TestimonialWaveCard';

// Import Swiper styles
import 'swiper/css';
import 'swiper/swiper-bundle.css';

type CardSliderProps = {
  children?: React.ReactNode;
  data: TestimonialWaveCardProps[];
};

const CardSlider: React.FC<CardSliderProps> = ({ data }) => {
  const swiperRef = useRef<SwiperType | null>(null);

  const nextSlide = () => {
    swiperRef.current?.slideNext();
  };

  const prevSlide = () => {
    swiperRef.current?.slidePrev();
  };

  return (
    <div className="mb-10 flex flex-row overflow-hidden rounded-4xl bg-gray-1 text-left text-white">
      <Swiper
        onBeforeInit={swiper => {
          swiperRef.current = swiper;
        }}
        loop={true}
        effect="fade"
        className="relative"
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
      >
        {data.map((item, index) => (
          <SwiperSlide key={index} className="mb-14 overflow-hidden">
            <TestimonialWaveCard {...item} />
          </SwiperSlide>
        ))}

        <div className="absolute bottom-4 left-1/2 z-10 flex -translate-x-1/2 transform cursor-pointer justify-center gap-4 md:bottom-4">
          <button
            onClick={prevSlide}
            className="flex size-10 items-center justify-center rounded-3xl border-2 border-gray-5 active:scale-90 active:transition active:duration-200 active:ease-in-out"
          >
            <ChevronLeftIcon className="size-6" />
          </button>
          <button
            onClick={nextSlide}
            className="flex size-10 items-center justify-center rounded-3xl border-2 border-gray-5 active:scale-90 active:transition active:duration-200 active:ease-in-out"
          >
            <ChevronRightIcon className="size-6" />
          </button>
        </div>
      </Swiper>
    </div>
  );
};

export default CardSlider;
